import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import InvitePartnerModal from '../../components/modal/InvitePartnerModal';
import { getShares } from '../../actions/shares';

const InvitePartnerDialog = ({ hideModal, modalType, refreshShares }) => {
  const recordId = modalType?.data?.recordId;
  const onShareCreated = recordId
    ? () => refreshShares(recordId)
    : null;

  return (
    <InvitePartnerModal
      hideModal={hideModal}
      modalType={modalType}
      onShareCreated={onShareCreated}
    />
  );
};

InvitePartnerDialog.propTypes = {
  hideModal: PropTypes.func.isRequired,
  modalType: PropTypes.shape({
    type: PropTypes.string,
    data: PropTypes.object,
  }).isRequired,
  refreshShares: PropTypes.func.isRequired,
};

export default connect(null, {
  refreshShares: getShares,
})(InvitePartnerDialog);
